export default {
  methods: {
    transformAdvicesList: function (data) {
      return [...data]?.map(({ isActive, ...rest }) => {
        return {
          ...rest,
          status: isActive,
        };
      });
    },
  },
};
